import server from './server'

export default {
    async register (username, authenticatorAttachment) {
        const options = server.createRegistrationOptions(username)

        options.authenticatorSelection.authenticatorAttachment = authenticatorAttachment
        options.timeout = 60 * 1000

        const credential = await navigator.credentials.create({
            publicKey: options,
        })

        return server.register(username, credential)
    },

    async login (username) {
        const options = server.createLoginOptions(username)
        options.timeout = 60 * 1000

        const assertion = await navigator.credentials.get({
            publicKey: options,
        })

        return server.login(username, assertion)
    },

    async plaformAvailable () {
        return window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable()
    },
}
